import { isLocalDev } from './env';

export const devLog = (...logs: unknown[]) => {
  if (isLocalDev && process.env['TESTING'] !== 'true') {
    console.debug('DEV> ', ...logs);
  }
};

export const devWarn = (...logs: unknown[]) => {
  if (isLocalDev && process.env['TESTING'] !== 'true') {
    console.warn('DEV> ', ...logs);
  }
};

export const devError = (...logs: unknown[]) => {
  if (isLocalDev && process.env['TESTING'] !== 'true') {
    console.error('DEV> ', ...logs);
  }
};

export function waitFor(ms: number) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}
